import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M13.5 5c-.276 0-.5.224-.5.5s.224.5.5.5h3.793L6 17.293V13.5c0-.276-.224-.5-.5-.5s-.5.224-.5.5v5c0 .276.224.5.5.5h5.001c.276 0 .5-.224.5-.5s-.224-.5-.5-.5H6.708L18.001 6.707V10.5c0 .276.224.5.5.5s.5-.224.5-.5v-5c0-.276-.224-.5-.5-.5H13.5z',
  ],
  height: 24,
  width: 24,
});
